import React from 'react';
import { isEmpty } from 'lodash';
import { Section, SectionHeader, RelatedArticles } from 'components';
import './LearnMore.scss';

const LearnMore = ({ allArticles, related }) => (
  <>
    <Section color={'gray-light'} additionalClass={'mvp__learn-more'}>
      <SectionHeader size={'big'} lineColor={'red'} fixed>
        Read more about MVP
      </SectionHeader>
    </Section>
    {!(isEmpty(allArticles) || isEmpty(related)) && (
      <RelatedArticles
        id={'mvp__learn-more-articles'}
        related={related}
        background={'gray-light'}
        allArticles={allArticles}
        sectionTitle={false}
        fixed
        bulletColor={'black'}
      />
    )}
  </>
);

export default LearnMore;
